import "./App.css";
import { useState, useEffect } from "react";
import cha from "./channels.json";

import Video from "./shakavideo";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import SpeedDial from "@mui/material/SpeedDial";

function App() {
  const [side, setSide] = useState(false);
  const lastPlayed = "";
  // localStorage.getItem("lastPlayed") ||
  // "https://dai.google.com/linear/hls/event/UcjHNJmCQ1WRlGKlZm73QA/master.m3u8";
  const [play, setPlay] = useState(lastPlayed);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const playTV = (url) => {
    console.log(url);
    setPlay(url);
  };

  return (
    <div className="base m-0 p-0" id="tvbox">
      <div className="row my-2">
        {cha.map((info, index) => {
          return (
            <div
              item
              xs={2}
              onClick={() => playTV(info.m3u)}
              className="col-lg-2 col-md-4 col-sm-6 col-6 my-2"
            >
              <Item className="bgcard">
                <img src={info.logo} className="chlogo" />
              </Item>
            </div>
          );
        })}
      </div>

      {play && (
        <Dialog
          fullScreen
          onClose={() => setPlay(null)}
          open={play}
          className="noScroll"
        >
          <SpeedDial
            ariaLabel="Close TV"
            sx={{
              position: "absolute",
              top: -30,
              right: -10,
            }}
            FabProps={{
              sx: {
                bgcolor: "#44444450",
                "&:hover": {
                  bgcolor: "red",
                },
              },
            }}
            icon={"X"}
            onClick={() => setPlay(null)}
          ></SpeedDial>
          <Video url={play} />
        </Dialog>
      )}
    </div>
  );
}

export default App;
